module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_3"
    }
  }, [_vm._v("3"), _c('br'), _vm._v("BLOWBACK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("Y")]), _vm._v("ousef was his nom de guerre. Another alias. Not only his name, but his precise date of birth—even the place—are still subject to question. Most intelligence analysts agree that his roots were in Baluchistan, a radical Islamic no-man’s-land the size of France that crosses the frontiers of Iran, Pakistan, and Afghanistan. By his own account he was raised in Kuwait, his father a Baluchistani and his mother a Palestinian."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_1",
      "id": "ne1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" One scholar contends that Yousef was an agent of Iraq who murdered a young Kuwaiti and hijacked his identity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_2",
      "id": "ne2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whoever he was, with his protruding ears and parrotlike nose, Yousef was a man of a dozen faces, posing in the same period as Arnaldo Forlani, a distinguished Italian parliamentarian; Dr. Abel Sabah, an Egyptian chemical specialist; and Dr. Naji Owaida Haddad, a Moroccan mechanical engineer."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_3",
      "id": "ne3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" At the height of his terror spree, when Yousef was dubbed “The Most Wanted” man on earth,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_4",
      "id": "ne4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" he manufactured his own fake ID and routinely changed his dress, hair, and eye color using contact lenses and skin dye to avoid capture."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_5",
      "id": "ne5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" But cosmetics could never conceal his scars: his fingers were disfigured, there were burn marks on the bottoms of his feet, and he was partially blind in his right eye—all casualties of his years as a bomb maker."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_6",
      "id": "ne6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Cold-blooded” and “diabolical” were the words used by men who had hunted him. “An evil genius,” said another."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_7",
      "id": "ne7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" But Yousef was immensely complex. A Sunni Muslim, he maintained a multivolume collection of the Koran,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_8",
      "id": "ne8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" and once reportedly set a bomb that killed twenty-six rival Shiites at a mosque in Iran."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_9",
      "id": "ne9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Yet he was far from devout: witnesses said he rarely attended Friday prayers at a mosque in Pakistan, and never fasted during Ramadan."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_10",
      "id": "ne10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a wife and two children,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_11",
      "id": "ne11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Yousef was also a notorious womanizer with a taste for first-class travel and Armani suits. Hours after murdering a young Japanese man with an airplane bomb, he was trolling the karaoke bars of Manila for B-girls."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_12",
      "id": "ne12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" But Yousef also showed a flare for the romantic. During the first of two federal trials in New York, he took Spanish lessons in order to woo an attractive Cuban-American attorney on his defense team. Even while he was in jail, with no visible means of income and the U.S. government financing his defense, he sent the young lawyer a lavish bouquet of flowers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_13",
      "id": "ne13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Yousef told FBI agents that he felt guilty about killing, but in the same breath he endorsed a plot to murder two hundred and fifty thousand people in New York in retaliation for U.S. support of Israel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_14",
      "id": "ne14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A new breed of terrorist” was how one U.S. intelligence operative described him."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_15",
      "id": "ne15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" And apart from his technical skill as an engineer and his ability to think outside the bomb box, what made Yousef so dangerous was his charm and charisma. A master recruiter of young men, he displayed an uncanny knack for convincing them to risk prison or die in the name of Allah. Yet he never even considered suicide for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A growing body of evidence now suggests that, between the first World Trade Center bomb and his construction of the 9/11 plot, Yousef may well have also designed the ammonium nitrate–nitromethane bomb that destroyed the Murrah Federal Building in Oklahoma City on April 19, 1995."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_16",
      "id": "ne16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Some have even suggested that he had a hand in the crash of TWA Flight 800."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_17",
      "id": "ne17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The former associate director of the FBI called him “the most dangerous and prolific terrorist since Carlos the Jackal.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_18",
      "id": "ne18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The general consensus in the intelligence community is that the man who became famous as Yousef was born Abdul Basit Mahmud Abdul Karim in Kuwait."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_19",
      "id": "ne19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" His father, an engineer named Mohammed Abdul Karim, had emigrated to Fuhayhil, a Kuwaiti oil boom town where young Yousef/Basit came of age.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1989 he earned a diploma in electronics from the West Glomorgan Institute of Higher Learning in South Wales. At the three-year technical college, he specialized in computer-aided electronics."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_20",
      "id": "ne20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Yousef was in Kuwait visiting family and friends in August of 1990 when Saddam Hussein’s tanks rolled in and took the country. His Iraqi connections would be the subject of debate among intelligence analysts for years to come. But sometime after the invasion, the twenty-three-year-old took off for the University of Dawa and Jihad, an al Qaeda training school located at the Jalozai refugee camp thirty miles east of Peshawar in northwest Pakistan."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_21",
      "id": "ne21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There, with fifty-five other young jihadis from around the world, Yousef took a six-month course, specializing in explosives."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_22",
      "id": "ne22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" He learned how to make slow-burning fuses using gunpowder rolled into cotton, or linen coated with an insulating layer of pitch. He studied the use of electrical switches, discovering that given the proper accelerant, the spark from a simple nine-volt battery would be sufficient to detonate a device of tremendous killing power."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_23",
      "id": "ne23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By one account, the gangly young Yousef sat in the back of a tent in the Jalozai camp as an instructor lectured in Arabic on how to build an effective improvised explosive device from an egg timer, some lamp cord, and an open can of gasoline."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_24",
      "id": "ne24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You must be careful how you set the timer,” the instructor said, splitting the ends of the lamp cord and twisting it around the poles of the small device.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stripped the other ends into a pig’s tail and taped them across the mouth of the gas can. “When the timer rings, it will send a charge along the wire which will short, causing a spark to ignite the gas vapors.” But he took care to admonish them: “These timers are unreliable. Always set them ahead. Five minutes can mean three.” He asked for a volunteer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Without hesitating, Yousef jumped up. He strutted like a young fighting gamecock toward the device. The instructor told him to get behind the sandbags, remove the pairs, reconnect them, and reset the timer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yousef nodded, cold as ice. He quickly examined the live device, then deftly removed the pairs. He reconnected them—then reset the timer for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one minute.")]), _vm._v(" The timer ticked away. But instead of running, Yousef walked slowly back around the sandbags. When the gas tank suddenly blew, Yousef was knocked to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Raging, the instructor ran up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Murtadd!")]), _vm._v("” he said. “Fool! You might have been killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Yousef eyed him defiantly. “Let the man who lacks the courage to do this for Allah go live with the women.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The instructor winced, then smiled at Yousef’s reckless bravery. The other students surrounded him. They fired AK-47s into the air in a blizzard of lead. Abdul Basit savored the triumph, and the legend of Ramzi Yousef was born.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_vm._v("The First Afghan War")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The irony was that Yousef acquired his bomb-building knowledge under the tutelage of men who were funded in part by Uncle Sam. In intelligence circles they call it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("blowback,")]), _vm._v(" a deadly unintended consequence of a covert op. In this case Yousef learned his deadly skills from men who, for years, had been supported and sponsored by the CIA.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the late 1980s the Central Intelligence Agency funneled billions in arms and munitions to the Afghan mujahadeen rebels in their war against the invading Soviets. The U.S. price tag for the covert aid reportedly reached three billion dollars. Journalist Mary Anne Weaver noted that the Soviet invasion, begun in 1979, was a kind of Spanish Civil War for Islamics. As many as twenty-five thousand young jihadis like Yousef poured in from around the globe to fight and train in guerrilla tactics."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_25",
      "id": "ne25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Though they were all later dubbed “Afghan Arabs,” there were blue-eyed Chechens, black South Africans, and Filipinos training along with Kurds, Yemenis, Uzbekis, and Saudis. They studied bombmaking, hijacking, and other covert ops. The difference was that the veterans of the antifascist campaign in the 1930s, like Hemingway, went to Paris to write books, while the Afghan War jihadis decided to focus their attention on the West and blow things up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During this period, intelligence officials believe that Yousef first hooked up with three men who would one day carve their names in the history of Islamic terror. Abdurajak Janjalani was a Libyan-trained Filipino whose nom de guerre was Abu Sayyaf."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_26",
      "id": "ne26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Mahmud Abouhalima was a six-foot-two redheaded Egyptian who did two tours in Afghanistan. Known as “the Red,” Abouhalima was a disciple of Sheikh Omar Abdel Rahman, leader of the al Gamm’a Islamiya (IG), one of the most virulent Egyptian terror groups."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_27",
      "id": "ne27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These Afghan connections would prove crucial to Yousef as his career advanced. Abouhalima would become one of his key operatives as he built the original World Trade Center bomb in 1992. Sheikh Rahman would be at the heart of Yousef’s bombing cell, based in Jersey City. Later, the Abu Sayyaf terror group, named for Janjalani, would provide Yousef with the infrastructure he needed when he plotted the 9/11 attacks in Manila in 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But the bomb maker’s chief sponsor over the years—the man who funded and guided him—was the seventeenth son of a Saudi construction billionaire named Osama bin Laden. Beginning in the early 1990s, Yousef emerged as the point man for bin Laden’s worldwide terror network. Al Qaeda, meaning “the base,” sprang directly from a string of refugee centers set up as fund-raising conduits for the mujahadeen rebels.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In short, when probing the origin of the 9/11 attacks, all roads lead back to Afghanistan and Peshawar in the final days of the Soviet invasion.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_vm._v("Working Russians")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Back in Texas, the call came early to Nancy Floyd. In the sixth grade, her teacher had asked the students at Inwood Elementary School to write essays on what they wanted to do in life. Nancy thought that she might serve with the CIA, or possibly the FBI. After all, her father, Tom, was an Air Force major. She’d grown up on bases all over Europe and the States, and watched her dad take off on dangerous, sometimes classified missions. One of her older brothers would become an Army captain. To Nancy, a job as an agent or case officer seemed like a sure way to contribute. Her teacher had other ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She sent a letter home to my parents that they should direct me toward a career in nursing or teaching,” remembered Nancy. “At the time there were no female agents.” But raised as a Catholic with a military work ethic, Nancy felt drawn toward another form of public service.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My dad worked for the government my whole life, and he was a very proud patriot,” she recalled. “That was what I wanted to do—work for the government in a way where I could help people and lock up bad guys. I was raised that there’s good and bad, and the good have to help put away the bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That keen Texas sense of justice drove Nancy through the University of Texas at Arlington, where she got her B.S. in criminal justice in 1982. By that point she had her sights fixed on the Bureau. Baby-sitting for the children of an FBI agent in Dallas throughout high school, she had marveled at how much he’d reminded her of her father, who had died of a sudden heart attack at the age of fifty-three. Nancy was shocked by his loss, but rule number one in the Floyd house was, you didn’t stay down for long. “We weren’t allowed to be moody,” said Nancy. “My mother would say, ‘This isn’t gonna work here, because you have so much to be grateful for. So let’s cut it and move on.’ And we did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Three years out of college, Nancy took the test for the Bureau. After a successful interview, she received a letter that she’d been accepted for training at the FBI Academy. There were only eight women in her starting class of sixty at Quantico. Right away she made friends with Martha Dixon and Icey Jenkins, two women who went on to distinguish themselves in the FBI."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_28",
      "id": "ne28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After receiving her coveted badge as a special agent, Nancy worked in Savannah, Georgia, where she qualified for the SWAT unit before being transferred to the FBI’s “flagship” office in New York. Soon, harking back to that sixth-grade essay, she found herself working in the best of both worlds: law enforcement and intelligence. Special Agent Floyd was assigned to Branch A in the Bureau’s Foreign Counter Intelligence Division (FCI). Located on the twenty-fifth floor at 26 Federal Plaza in Manhattan, FCI was the unit tasked to gather intel on the GRU (Glavnoe Razvedyvatelnoe Upravlenie), the intelligence unit of the Russian army. In the FBI shadow world that monitored the GRU, Nancy began learning tradecraft from one of the Bureau’s top agents, Len Predtechenskis.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For twenty-seven years, from the last frigid days of the Cold War through glasnost and the breakup of the Soviet Union, Predtechenskis was a secret weapon in the FBI’s New York Office. Born in Latvia, fluent in English, Latvian, and Russian, the former Leonids Predtechenskis became the FBI’s chief counterintelligence agent in Manhattan."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#ne_29",
      "id": "ne29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In 2001, after holding the record for the longest Russian double agent recruitment in FBI history (twenty-five years), Len reached the mandatory retirement age. The “brag wall” in his den would rival that of any U.S. senator or congressman, with commendations or letters of praise from Presidents Richard Nixon and George W. Bush and every FBI director since Hoover. But one of his proudest accomplishments was the mentoring and support he gave to a young Texas recruit named Nancy Floyd. “I’m old school,” said Len. “Frankly, I’m the type who had no use for female agents in the Bureau. That’s until I met Nancy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Agent Floyd came to the New York office full of piss and vinegar. Driven, bright, and sometimes a tad outspoken, she was hungry to learn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I told her, ‘We’re working Russians,’ ” Predtechenskis remembered. “ ‘So educate yourself. Go out and find Hedrick Smith’s book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Russians.")]), _vm._v("’ She had it read the next day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nancy was ready for more, so Predtechenskis suggested that she reactivate the Hotel Asset Program, an initiative he’d started in the 1970s.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I used to go to hotels and talk to the front-desk managers,” said Len. “I’d give them my card and ask them to be on the lookout for any stray diplomats for the Soviet mission. Let me know if any of them got into trouble. We developed a lot of doubles this way. So I suggested that Nancy work it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One day, in August of 1991, she stopped off at a hotel in midtown Manhattan. Without realizing it, Nancy Floyd was about to meet a source that would put her next to the most dangerous threat to American homeland security since the Cuban missile crisis.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e31eedbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 87
// module chunks = 0